import axios from 'axios';

// Caps buffered response/request size to protect job heap (worker runs up to QUEUE_PREFETCH jobs).
// Only buffered responses are bounded; responseType: 'stream' is unaffected. Tune via HTTP_MAX_CONTENT_MB.
const MAX_BYTES = (Number(process.env.HTTP_MAX_CONTENT_MB) || 100) * 1024 * 1024;
axios.defaults.maxContentLength = MAX_BYTES;
axios.defaults.maxBodyLength = MAX_BYTES;

export const http = {
  axios,
  get: axios.get,
  post: axios.post,
  put: axios.put,
  patch: axios.patch,
  delete: axios.delete,
  head: axios.head,
  options: axios.options,
};